import { render } from "./EnbPreferenceGeral.vue?vue&type=template&id=64a97b4e&scoped=true"
import script from "./EnbPreferenceGeral.vue?vue&type=script&lang=js"
export * from "./EnbPreferenceGeral.vue?vue&type=script&lang=js"

import "./EnbPreferenceGeral.vue?vue&type=style&index=0&id=64a97b4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a97b4e"]])

export default __exports__